
import config from '@/../config'
// 配置
Object.assign(config, {
	name: '管理平台',
})

export default config
